import api from './api';
import { LoginCredentials, Token, User, UserCreate } from '../types';
import { cleanRUT } from '../utils/validators';

export const authService = {
  async login(credentials: LoginCredentials): Promise<Token> {
    const formData = new FormData();
    formData.append('username', cleanRUT(credentials.username));
    formData.append('password', credentials.password);
    
    const response = await api.post<Token>('/login/access-token', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    const token = response.data;
    localStorage.setItem('access_token', token.access_token);
    
    return token;
  },

  async register(userData: UserCreate): Promise<User> {
    const cleanedUserData = {
      ...userData,
      rut: cleanRUT(userData.rut)
    };
    
    const response = await api.post<User>('/users/', cleanedUserData);
    return response.data;
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get<User>('/users/me');
    return response.data;
  },

  async updateUser(userData: Partial<User>): Promise<User> {
    const response = await api.put<User>('/users/me', userData);
    return response.data;
  },

  async verifyPassword(password: string): Promise<void> {
    await api.post('/users/me/verify-password', { password });
  },

  async exportUserData(password: string): Promise<Blob> {
    const response = await api.post('/users/me/export', { password }, {
      responseType: 'blob',
    });
    return response.data;
  },

  async deleteAccount(password: string): Promise<void> {
    await api.delete('/users/me', { data: { password } });
    this.logout();
  },

  logout(): void {
    localStorage.removeItem('access_token');
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('access_token');
  },
}; 